import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IContactState } from './contact.state';

export class ContactSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly contactState = (state: IRootState): IContactState => {
    return state.contact as IContactState;
  };

  static readonly model = createSelector(ContactSelectors.contactState, (contact: IContactState) => {
    return contact.model;
  });

  static readonly data = createSelector(ContactSelectors.contactState, (contact: IContactState) => {
    return contact.data;
  });

  static readonly clubMembership = createSelector(ContactSelectors.contactState, (contact: IContactState) => {
    return contact.clubMembership;
  });
}
